import * as React from 'react';

import {List} from '@common/typescript/objects/List';

import Musthead from '@app/components/UI/MustHead/Musthead';
import LinkBlockSmall from '@app/components/UI/LinkBlock/LinkBlockSmall';
import {LinkBlockItemActive} from '@app/objects/LinkBlockItem';
import RichText from '@app/components/UI/RichText/RichText';
import {
	veterinaryHospiceText1,
	veterinaryHospiceText2,
	veterinaryHospiceText3,
	veterinaryHospiceText4,
	videoText,
	videoUrl,
	videoTitle, covidWarning
} from '@app/components/Pages/Services/VeterinaryHospice/veterinaryHospiceContent';
import {Questions} from '@app/objects/Questions';
import {rest} from '@app/components/Api';
import FaqBlockHeaderSm from '@app/components/UI/FaqBlock/FaqBlockHeaderSm';
import FaqBlock from '@app/components/UI/FaqBlock/FaqBlock';
import VideoEmbed from '@app/components/UI/VideoEmbed/VideoEmbed';
import withSeo from '@app/components/LocalCommon/HigherOrderComponents/WithSeo';

const VeterinaryHospice = () => {
	const [questions, setQuestions] = React.useState<Questions[]>([]);

	React.useEffect(() => {
		rest.get<List<Questions>>('v1/faq/hospicePage').then(res => setQuestions(res.list));
	}, []);

	const linkItems: LinkBlockItemActive[] = [
		{
			path: '/our-services/veterinary-hospice',
			name: 'Veterinary Hospice',
			active: true,
		},
		{
			path: '/our-services/in-home-euthanasia',
			name: 'In-Home Euthanasia',
		},
		{
			path: '/our-services/aftercare',
			name: 'Aftercare',
		},
		{
			path: '/our-services/telehospice',
			name: 'Telehospice',
		},
		{
			path: '/our-services/pet-loss-support',
			name: 'Pet Loss Support',
		},
	];

	return (
		<div className="vet-hospice our-services">
			<Musthead
				title="Veterinary Pet Hospice"
				imageSrc={require('@app/content/veterinary_hospice.png')}
				text="Illness and death do not happen because medicine fails. They happen because it is the natural progression of life."
				quoteAuthor="Dr. Dani McVety"
				imageAlt="Veterinary pet hospice"
			/>
			<RichText
				title="What is veterinary dog hospice and cat hospice?"
				text={veterinaryHospiceText1}
			/>
			<RichText
				title="Why choose veterinary hospice?"
				text={veterinaryHospiceText2}
			/>
			<RichText
				title="Veterinary hospice care may include, but is not limited to..."
				text={veterinaryHospiceText3}
			/>
			<VideoEmbed
				text={videoText}
				videoSrc={videoUrl}
				videoTitle={videoTitle}
			/>
			<RichText
				title="Choosing a natural death"
				text={veterinaryHospiceText4}
			/>
			<div className="care-coordinator__faq">
				<div className="care-coordinator__faq-content">
					<FaqBlockHeaderSm
						title="You might find yourself asking..."
						btnText="View all FAQ"
						clickUrl="/faq"
					/>
					<FaqBlock questions={questions} />
				</div>
			</div>
			<LinkBlockSmall items={linkItems} />
		</div>
	);
};

export default withSeo(VeterinaryHospice, state => state.veterinaryHospicePage, 'veterinaryHospicePage', 'our-services/veterinary-hospice');